import React from 'react'
import Slider from "react-slick";
import imgAlc from '../../Components/assets/Logos_clientes/Alcaldia.png'
import imgGob from '../../Components/assets/Logos_clientes/Gob.png'
import imgNac from '../../Components/assets/Logos_clientes/Nacional.png'
import imgValle from '../../Components/assets/Logos_clientes/Valle.png'
import imgDag from '../../Components/assets/Logos_clientes/DAGMA.png'
import imgErt from '../../Components/assets/Logos_clientes/ERT.png'
import imgCelsia from '../../Components/assets/Logos_clientes/logoCelsia.png'
import { NavArrowLeft, NavArrowRight } from 'iconoir-react';
const SliderCases = () => {

    const Empresas = [
        { id: 1, name: 'Alcaldía Santiago de Cali.', image: imgAlc },
        { id: 2, name: 'Gobernación del Valle.', image: imgGob },
        { id: 3, name: 'Escuela Nacional del Deporte.', image: imgNac },
        { id: 4, name: 'Universidad del Valle', image: imgValle },
        { id: 5, name: 'Departamento Administrativo de Gestión de Medio Ambiente.', image: imgDag },
        { id: 6, name: 'ERT', image: imgErt },
        { id: 6, name: 'Celsia.', image: imgCelsia }

    ];


    const settings = {
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: Empresas.length > 3 ? 3 : Empresas.length,
        slidesToScroll: 1,
        initialSlide: 1,
        dots: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
          {
            breakpoint: 1774,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 682,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
            },
          },
        ],
      };

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{
              ...style,
              display: "block",
              background: "#a3a3a3",
              borderRadius: "100px",
            }}
            onClick={onClick}
          >
            <NavArrowRight />
          </div>
        );
      }
    
      function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
          <div
            className={className}
            style={{
              ...style,
              display: "block",
              background: "#a3a3a3",
              borderRadius: "100px",
            }}
            onClick={onClick}
          >
            <NavArrowLeft />
          </div>
        );
      }
    
    return (
        <div id="slider-container" className="max-w-4xl mx-auto mt-12">
            <Slider {...settings}>
                {Empresas.map((items) => {
                    return (
                        <div key={items.id}  >
                            <a href="" className='flex flex-col justify-center items-center px-10 text-sm no-underline shadow-sm h-48 sm:w-80 w-full  my-10'>
                                <img className='w-3/5 p-20 sm:p-8 sm:w-96' src={items.image} alt="" />
                                {/* <p>
                                    {items.name}
                                </p> */}
                            </a>

                        </div>
                    );
                })}
            </Slider>
        </div>
    )
}

export default SliderCases
